export default "__VITE_ASSET__28ba362a__"